import React, { useState } from 'react';
import {
  Flex,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Box,
} from '@chakra-ui/react';
import { MdOutlineRefresh } from 'react-icons/md';
import moment from 'moment';
import Card from 'components/card/Card';
import { LockerLedgerStatus } from 'config/constant';

const LockerLedger = (props) => {
  const ledgerList = props.ledger;

  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  return (
    <Flex
      height='100%'
      direction='column'>
      <Card
        mt={4}
        direction='column'
        bgColor='gray.200'
        w='100%'
        minHeight='12rem'
        maxHeight='42rem'
        px='0px'
        overflowX='scroll'>
        <Flex overflow='visible'>
          <Table
            variant='simple'
            color='gray.500'
            mb='24px'>
            <Thead>
              <Tr>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Gold Weight
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Price / Gram
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Amount
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Advance Amount
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Transaction Date
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Status
                  </Flex>
                </Th>
              </Tr>
            </Thead>

            <Tbody>
              {ledgerList?.map((obj, index) => {
                return (
                  // <Link to={{ pathname: '/permission-group', state: obj.id }}>
                  <Tr key={obj.id}>
                    <Td>
                      <Flex align='center'>
                        {obj.transaction_type === 'CREDIT' ? (
                          <Text
                            me='10px'
                            color='green'
                            fontSize='sm'
                            fontWeight='700'>
                            + {isNaN(parseFloat(obj.weight)) ? 'N/A' : parseFloat(obj.weight).toFixed(3)} gms
                          </Text>
                        ) : (obj.transaction_type === 'DEBIT'|| obj.transaction_type === 'PICKUP') ? (
                          <Text
                            me='10px'
                            color='red'
                            fontSize='sm'
                            fontWeight='700'>
                            - {isNaN(parseFloat(obj.weight)) ? 'N/A' : parseFloat(obj.weight).toFixed(3)} gms
                          </Text>
                        ) : (
                          <Text
                            me='10px'
                            fontSize='sm'
                            fontWeight='700'>
                            {isNaN(parseFloat(obj.weight)) ? 'N/A' : parseFloat(obj.weight).toFixed(3)} gms
                          </Text>
                        )}
                      </Flex>
                    </Td>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          Rs {obj.gold_price} 
                        </Text>
                      </Flex>
                    </Td>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          Rs {obj.amount}
                        </Text>
                      </Flex>
                    </Td>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          Rs {obj.extra_amount}
                        </Text>
                      </Flex>
                    </Td>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          {moment(obj.date_of_payment).format(
                            'DD MMM YY, HH:mm'
                          )}
                        </Text>
                      </Flex>
                    </Td>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          {
                            LockerLedgerStatus.find(
                              (option) => option.value === obj?.status
                            )?.label
                          }
                        </Text>
                      </Flex>
                    </Td>

                    {/* <Td>
                      <TransactionStatus
                        propFunct={props.propFunct}
                        status={obj.status}
                        id={obj.id}
                      />
                    </Td> */}
                  </Tr>
                  // </Link>
                );
              })}
            </Tbody>
          </Table>
        </Flex>
      </Card>
    </Flex>
  );
};

export default LockerLedger;
